
import { useParams, Link } from "react-router-dom";
import { businesses } from "../../mocks/businessData";
import BusinessHero from "./components/BusinessHero";
import BusinessFeatures from "./components/BusinessFeatures";
import BusinessCases from "./components/BusinessCases";
import BusinessCTA from "./components/BusinessCTA";
import DetailNavbar from "./components/DetailNavbar";
import Footer from "../home/components/Footer";
import { useState, useEffect } from "react";

export default function BusinessDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [scrolled, setScrolled] = useState(false);
  const business = businesses.find((b) => b.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [id]);

  if (!business) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-white">
        <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-full mb-4">
          <i className="ri-error-warning-line text-3xl text-gray-400"></i>
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">未找到该业务</h2>
        <Link
          to="/"
          className="mt-4 px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-full hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    );
  }

  const currentIndex = businesses.findIndex((b) => b.id === id);
  const prevBusiness = currentIndex > 0 ? businesses[currentIndex - 1] : null;
  const nextBusiness = currentIndex < businesses.length - 1 ? businesses[currentIndex + 1] : null;

  return (
    <div className="min-h-screen bg-white">
      <DetailNavbar scrolled={scrolled} />
      <BusinessHero business={business} />
      <BusinessFeatures business={business} />
      <BusinessCases business={business} />

      {/* 上下业务导航 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">探索更多核心业务</h3>
          <div className="grid md:grid-cols-2 gap-6">
            {prevBusiness && (
              <Link
                to={`/business/${prevBusiness.id}`}
                className="group flex items-center gap-4 bg-white rounded-xl p-6 hover:shadow-lg transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full group-hover:bg-teal-50 transition-colors flex-shrink-0">
                  <i className="ri-arrow-left-line text-lg text-gray-500 group-hover:text-teal-600 transition-colors"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-gray-400 mb-1">上一个业务</p>
                  <p className="text-sm font-semibold text-gray-800 group-hover:text-teal-600 transition-colors truncate">{prevBusiness.title}</p>
                </div>
              </Link>
            )}
            {nextBusiness && (
              <Link
                to={`/business/${nextBusiness.id}`}
                className="group flex items-center justify-end gap-4 bg-white rounded-xl p-6 hover:shadow-lg transition-all duration-300 cursor-pointer md:col-start-2"
              >
                <div className="min-w-0 text-right">
                  <p className="text-xs text-gray-400 mb-1">下一个业务</p>
                  <p className="text-sm font-semibold text-gray-800 group-hover:text-teal-600 transition-colors truncate">{nextBusiness.title}</p>
                </div>
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full group-hover:bg-teal-50 transition-colors flex-shrink-0">
                  <i className="ri-arrow-right-line text-lg text-gray-500 group-hover:text-teal-600 transition-colors"></i>
                </div>
              </Link>
            )}
          </div>
        </div>
      </section>

      <BusinessCTA />
      <Footer />
    </div>
  );
}
